import React from "react";
import {
  FormControlLabel,
  Checkbox as MUICheckbox,
  CheckboxProps,
} from "@material-ui/core";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: flex;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 18px;
`;

function Checkbox({ inputLabel, error, label, ...rest }: ICheckbox) {
  return (
    <Wrapper>
      {inputLabel && <Label htmlFor={"input-" + rest.name}>{inputLabel}</Label>}
      <FormControlLabel
        style={{ color: "rgba(102,102,102,0.8)", fontSize: "12px" }}
        control={
          <MUICheckbox id={"input-" + rest.name} {...rest} color="primary" />
        }
        label={label}
      />
      {error && <span style={{ color: "red" }}>{error}</span>}
    </Wrapper>
  );
}

export interface ICheckbox extends CheckboxProps {
  inputLabel?: string;
  label?: string;
  error?: string | number;
}

export default Checkbox;
